import { render, staticRenderFns } from "./companyPriceOnlyRead.vue?vue&type=template&id=74b18924"
import script from "./companyPriceOnlyRead.vue?vue&type=script&lang=js"
export * from "./companyPriceOnlyRead.vue?vue&type=script&lang=js"
import style0 from "./companyPriceOnlyRead.vue?vue&type=style&index=0&id=74b18924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports